export const timelogs = state => state.timelogs.items
export const timelogById = state => id => _.find(timelogs(state), {id})
export const timelogsByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let item = timelogById(state)(id)
        if (item) res.push(item)
        return res
    }, [])
}

export const timelogsByProjectId = (state, getters) => projectId => _.filter(getters.timelogs, {project_id: parseInt(projectId)})

export const timelogActivityName = (state, getters) => timelog => {
    switch (timelog.activity_type) {
        case 'task':
            return getters.taskNameById(timelog.activity_id)
        case 'project-service':
            return getters.projectServiceNameById(timelog.activity_id)
        case 'dictionary':
            return getters.categoryNameById(timelog.activity_id)
        default:
            return '';
    }
}

export const isGlobalTimelogActive = state => state.timelogs.globalTimelog.active
export const isGlobalTimelogClosable = state => state.timelogs.globalTimelog.closable
export const isGlobalTimelogShort = state => state.timelogs.globalTimelog.isShort
export const isGlobalTimelogAutoFill = state => state.timelogs.globalTimelog.autoFill
export const globalTimelogProjectId = state => state.timelogs.globalTimelog.project_id
export const globalTimelogActivityType = state => state.timelogs.globalTimelog.activity_id ? state.timelogs.globalTimelog.activity_type : 'project'
export const globalTimelogActivityId = state => state.timelogs.globalTimelog.activity_id
